{
    "Accessibility menu": "പ്രവേശയോഗ്യത മെനു",
    "Close": "അടയ്ക്കുക",
    "Content adjustments": "ഉള്ളടക്ക ക്രമീകരണങ്ങൾ",
    "Navigation adjustments": "നാവിഗേഷൻ ക്രമീകരണങ്ങൾ",
    "Text Align": "ടെക്‌സ്റ്റ് വിന്യാസം",
    "Align Left": "ഇടത് വിന്യസിക്കുക",
    "Align Center": "മധ്യത്തിൽ വിന്യസിക്കുക",
    "Align Right": "വലത്തേക്ക് വിന്യസിക്കുക",
    "Adjust Font Size": "അക്ഷരത്തിന്റെ വലുപ്പം ക്രമീകരിക്കുക",
    "Highlight Title": "ശീർഷകം ഹൈലൈറ്റ് ചെയ്യുക",
    "Highlight Links": "ലിങ്കുകൾ ഹൈലൈറ്റ് ചെയ്യുക",
    "Readable Font": "വായിക്കാൻ എളുപ്പമുള്ള ഫോണ്ട്",
    "Colour adjustments": "നിറ ക്രമീകരണങ്ങൾ",
    "Dark Contrast": "ഇരുണ്ട കോൺട്രാസ്റ്റ്",
    "Light Contrast": "ഇളം കോൺട്രാസ്റ്റ്",
    "High Contrast": "ഉയർന്ന കോൺട്രാസ്റ്റ്",
    "High Saturation": "ഉയർന്ന സാച്ചുറേഷൻ",
    "Low Saturation": "കുറഞ്ഞ സാച്ചുറേഷൻ",
    "Monochrome": "മോനോക്രോം",
    "Tools": "ഉപകരണങ്ങൾ",
    "Reading Guide": "വായനാ ഗൈഡ്",
    "Big Cursor": "വലിയ കർസർ",
    "Increase Font Size": "ഫോണ്ട് വലുപ്പം വർദ്ധിപ്പിക്കുക",
    "Decrease Font Size": "ഫോണ്ട് വലുപ്പം കുറയ്ക്കുക",
    "Letter Spacing": "അക്ഷരങ്ങൾക്കിടയിലെ ഇടവ്",
    "Line Height": "ലൈൻ ഉയരം",
    "Font Weight": "ഫോണ്ട് ഭാരം",
    "Dyslexia Font": "ഡിസ്ലെക്സിയ ഫോണ്ട്",
    "Language": "ഭാഷ",
    "Accessibility widget": "പ്രവേശയോഗ്യത മെനു തുറക്കുക",
    "Accessibility Profiles": "പ്രവേശയോഗ്യത പ്രൊഫൈലുകൾ",
    "Cognitive Disability": "ജ്ഞാനപരമായ വൈകല്യം",
    "Seizure Safe": "അപസ്മാരത്തിന് സുരക്ഷിതം",
    "Accessibility statement": "പ്രവേശയോഗ്യത പ്രസ്താവന",
    "ADHD": "ADHD",
    "Low Vision": "കുറഞ്ഞ കാഴ്ച",
    "Pause Animations": "ആനിമേഷനുകൾ നിർത്തുക",
    "Animation paused": "ആനിമേഷൻ താൽക്കാലികമായി നിർത്തി",
    "Reset all settings": "ക്രമീകരണങ്ങൾ പുനഃസജ്ജമാക്കുക",
    "Shortcut:": "കുറുക്കുവഴി:",
    "Epilepsy Safe Mode": "അപസ്മാര സുരക്ഷിത മോഡ്",
    "Mute sounds": "ശബ്ദങ്ങൾ നിശ്ശബ്ദമാക്കുക",
    "Page read": "പേജ് വായിക്കുക",
    "Page read controls": "പേജ് വായന നിയന്ത്രണങ്ങൾ",
    "Pause": "താൽക്കാലികമായി നിർത്തുക",
    "Resume": "പുനരാരംഭിക്കുക",
    "Stop": "നിർത്തുക",
    "Settings": "ക്രമീകരണങ്ങൾ",
    "Speed": "വേഗത",
    "Voice": "ശബ്ദം",
    "Close accessibility menu": "പ്രവേശനക്ഷമത മെനു അടയ്ക്കുക",
    "Back to accessibility menu": "പ്രവേശനക്ഷമത മെനുവിലേക്ക് മടങ്ങുക",
    "Search languages": "ഭാഷകൾ തിരയുക",
    "Selected language": "തിരഞ്ഞെടുത്ത ഭാഷ",
    "View accessibility statement (opens in new window)": "പ്രവേശനക്ഷമത പ്രസ്താവന കാണുക (പുതിയ വിൻഡോയിൽ തുറക്കുന്നു)",
    "Visit CookieYes website (opens in new window)": "CookieYes വെബ്‌സൈറ്റ് സന്ദർശിക്കുക (പുതിയ വിൻഡോയിൽ തുറക്കുന്നു)",
    "Reset all accessibility settings to default": "എല്ലാ പ്രവേശനക്ഷമത ക്രമീകരണങ്ങളും ഡിഫോൾട്ടിലേക്ക് പുനഃസജ്ജമാക്കുക"
}
